import { render } from "./z-pin-list.vue?vue&type=template&id=b2d17e3e&scoped=true&ts=true"
import script from "./z-pin-list.vue?vue&type=script&lang=ts"
export * from "./z-pin-list.vue?vue&type=script&lang=ts"

import "./z-pin-list.vue?vue&type=style&index=0&id=b2d17e3e&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d17e3e"]])

export default __exports__